/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Fail_Supadata_MissingInputs */

const en_import_fail_supadata_missing = /** @type {(inputs: Import_Fail_Supadata_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos need a Supadata key (Settings → AI)`)
};

const de_import_fail_supadata_missing = /** @type {(inputs: Import_Fail_Supadata_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos brauchen einen Supadata-Schlüssel (Optionen → KI)`)
};

/**
* | output |
* | --- |
* | "Videos need a Supadata key (Settings → AI)" |
*
* @param {Import_Fail_Supadata_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_fail_supadata_missing = /** @type {((inputs?: Import_Fail_Supadata_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Fail_Supadata_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_fail_supadata_missing(inputs)
	return en_import_fail_supadata_missing(inputs)
});